import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["preview"]

  connect() {
    console.log("Form Preview controller connected")
    this.disablePreviewForm()
  }

  update(event) {
    const formType = event.target.value
    fetch(`/account_settings/sales_settings/preview?form_type=${formType}`, {
      headers: {
        'Accept': 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.text())
    .then(html => {
      this.previewTarget.innerHTML = html
      this.disablePreviewForm()
    })
  }

  disablePreviewForm() {
    const previewForm = this.previewTarget.querySelector('form')
    if (previewForm) {
      previewForm.querySelectorAll('input, select, textarea').forEach(element => {
        element.disabled = true
      })
      const submitButton = previewForm.querySelector('input[type="submit"]')
      if (submitButton) {
        submitButton.disabled = true
        submitButton.classList.add('opacity-50', 'cursor-not-allowed')
      }
    }
  }
}